// extracted by mini-css-extract-plugin
export default {"SectionContainer":"Overview-module__SectionContainer--UtR6t","TableFooter":"Overview-module__TableFooter--jntkX"};